export default __webpack_public_path__ + "static/media/Poppins-Light.530ca461.woff";